// extracted by mini-css-extract-plugin
module.exports = {"faqs":"FAQs_faqs__aXZJm","slide-in-right":"FAQs_slide-in-right__buktk","slide-out-right":"FAQs_slide-out-right__12Per"};